import { Component, Input } from '@angular/core';

import { GoBackDirective } from '@cure-common/directives';

@Component({
  selector: 'app-order-header',
  standalone: true,
  imports: [GoBackDirective],
  templateUrl: './order-header.component.html',
  styleUrl: './order-header.component.scss',
})
export class OrderHeaderComponent {
  @Input({ required: true }) title: string;
}
